import "../../../../content/projects/k29/k29.css";
import * as React from 'react';
export default {
  React
};